import React, { useState } from "react";
import { ModalWithIcon } from "../../RfModal/ModalWithIcon";
import { CancellationOfferDefinition } from "@functions/plans/info/cancellationOffers";
import { openOnboardingCalendly } from "../../../../../clientServices/openOnboardingCalendly";

type CancelPlanExternalLinkModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onCancel: () => void;
    offer: CancellationOfferDefinition;
};

export function CancelPlanExternalLinkModal({
    isOpen,
    onClose,
    onCancel,
    offer
}: CancelPlanExternalLinkModalProps) {
    const [loadingAction, setLoadingAction] = useState<"accept" | "cancel" | null>(null);

    const handleAccept = () => {
        setLoadingAction("accept");
        if (offer.variantConfig.openAction === "openOnboardingCalendly") {
            openOnboardingCalendly("cancellation_offer");
        }
        eventTracker.event({ type: "Cancellation Offer Accepted", data: { offer_id: offer.id } });
        onClose();
    };

    const handleCancel = async () => {
        setLoadingAction("cancel");
        await onCancel();
    };

    return (
        <ModalWithIcon
            isOpen={isOpen}
            onClose={onClose}
            title={offer.heading}
            icon={offer.icon}
            cancelButtonText="No Thanks, Cancel Now"
            submitButtonText={offer.ctaText}
            type="info"
            onCancel={handleCancel}
            onSubmit={handleAccept}
            submitButtonProps={{ disabled: !!loadingAction, loading: loadingAction === "accept" }}
            cancelButtonProps={{ disabled: !!loadingAction, loading: loadingAction === "cancel" }}
            closeOnCancel={false}
        >
            <p className="text-sm text-gray-700">{offer.description}</p>
        </ModalWithIcon>
    );
}
